enum ECopyButtonVariant {
    Gray = "gray",
    Blue = "blue"
}

export { ECopyButtonVariant }
